module.exports = __webpack_public_path__ + "img/galeria-video-5.efa5fb8b.png";